(function () {
  var SECTION_SELECTOR = '.oddit-section-featured-press';

  function initSection(section) {
    var slides = section.querySelectorAll('.oddit-section-featured-press__slide');
    var prevBtn = section.querySelector('[data-press-prev]');
    var nextBtn = section.querySelector('[data-press-next]');
    var total = slides.length;
    if (total < 2) return;

    var current = 0;
    for (var i = 0; i < total; i++) {
      if (!slides[i].hidden) current = i;
    }

    /* ── Autoplay ── */
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = (parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5) * 1000;
    var timer = null;

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(function () {
        show((current + 1) % total);
      }, speed);
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);

    // Each slide holds its own logo / publication name, so toggling the slide is
    // all it takes to keep the visible source in sync with the active quote.
    function show(index) {
      for (var i = 0; i < total; i++) {
        slides[i].hidden = i !== index;
      }
      current = index;
      /* Reset autoplay timer on every slide change */
      if (timer) { stopAutoplay(); startAutoplay(); }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show((current - 1 + total) % total);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show((current + 1) % total);
      });
    }

    /* ── Theme editor: jump to the selected quote block ── */
    function onBlockSelect(e) {
      for (var i = 0; i < total; i++) {
        if (slides[i] === e.target || slides[i].contains(e.target)) {
          stopAutoplay();
          show(i);
          return;
        }
      }
    }
    section.addEventListener('shopify:block:select', onBlockSelect);

    show(current);
    startAutoplay();

    /* ── Cleanup for theme editor ── */
    section._pressCleanup = function () {
      stopAutoplay();
      section.removeEventListener('mouseenter', stopAutoplay);
      section.removeEventListener('mouseleave', startAutoplay);
      section.removeEventListener('focusin', stopAutoplay);
      section.removeEventListener('focusout', startAutoplay);
      section.removeEventListener('shopify:block:select', onBlockSelect);
    };
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section && section._pressCleanup) section._pressCleanup();
  });
})();